import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { useState } from 'react'
import {
  Image,
  Platform,
  SafeAreaView,
  StatusBar as RNStatusBar,
  StyleSheet,
  TouchableOpacity,
  View
} from 'react-native'

import { Palette } from '@ppwr/poker'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { ClassListSelection } from './ClassListSelection'
import { useRouter } from 'expo-router'
import { defaultBreakPoints, isWeb } from '@/components/WebWrapper'

const classesList = ['Beginner', 'Intermediate', 'Advanced', 'Private']

export const WhichClassTypeScreen = () => {
  const router = useRouter()
  const store = useStore()
  const [selectedClassType, setSelectedClassType] = useState<string>('')

  const onNext = () => {
    trackEvent(selectedClassType)
    router.navigate('/onboarding/change-name')
  }

  const onBack = () => {
    router.replace('/onboarding/where-are-you')
  }

  const handlePress = (classType: string) => {
    setSelectedClassType(classType)
  }

  const trackEvent = (classType: string) => {
    store.analytics.setEvent(events.onboarding.class_type_form_completed, {
      classType,
      segmentUserId: store.analytics.getSegmentUserID(),
      segmentIdentity: store.analytics.getUserIdentify()
    })
  }

  return (
    <SafeAreaView style={styles.safeAreaView}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <View style={styles.webContainer}>
        <DS.Frame style={styles.container}>
          <DS.Frame style={styles.mainContent}>
            <TouchableOpacity onPress={onBack} style={styles.backButton}>
              <Image
                style={{ height: 24, width: 24 }}
                source={require('../../../assets/userInfo/back.png')}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <DS.Frame gap="32">
              <DS.Text variant="Heading 2/Regular">Which class type?</DS.Text>
              <ClassListSelection list={classesList} onPress={handlePress} />
            </DS.Frame>
          </DS.Frame>
          <DS.Button
            onPress={onNext}
            disabled={!selectedClassType}
            variant="Large/Primary"
            type="On Light"
            style={{ alignSelf: 'flex-end', marginBottom: 16 }}
          >
            Next
          </DS.Button>
        </DS.Frame>
      </View>
    </SafeAreaView>
  )
}

export const styles = StyleSheet.create({
  webContainer: {
    width: '100%',
    maxWidth: isWeb ? defaultBreakPoints.sm : undefined,
    marginHorizontal: isWeb ? 'auto' : undefined
  },
  safeAreaView: {
    flexGrow: 1,
    backgroundColor: Palette['Brand/Cream'],
    paddingTop: Platform.OS === 'android' ? RNStatusBar.currentHeight : 0,
    paddingBottom: Platform.OS === 'android' ? 16 : 0
  },
  backButton: {
    paddingTop: 16 //Platform.OS === 'android' ? 20 : 0
  },
  container: {
    paddingHorizontal: 24,
    height: '100%',
    justifyContent: 'space-between',
    gap: 32
  },
  mainContent: {
    gap: 20
  }
})
